import type {PlatformMediaType, SocialMediaAccountId} from '@Components/social-media/post.vo';

export enum PostDetailsActionMode {
  NAVIGATE = 'NAVIGATE',
  PUBLISH = 'PUBLISH',
  SCHEDULE = 'SCHEDULE',
}

export const MAX_ACCOUNT_BUTTONS_TO_SHOW = 7;

export interface MaxVisiblePublishingParamInfo {
  accountId: SocialMediaAccountId;
  publishingParamIndex: number;
  mediaType: PlatformMediaType;
}
